import { createFeatureSelector, createSelector } from '@ngrx/store';
import { billingPaymentInfoFeatureKey } from '../reducers';
import { BillingPaymentInfoState } from '../reducers/billing-payment-info.reducer';

export const selectBillingPaymentInfo =
  createFeatureSelector<BillingPaymentInfoState>(billingPaymentInfoFeatureKey);

export const selectPaymentInfoByAccountNumber = (accountNumber: string) =>
  createSelector(
    selectBillingPaymentInfo,
    (state) => state.byAccountNumber[accountNumber]
  );

export const selectPaymentInfoHasError = createSelector(
  selectBillingPaymentInfo,
  (state) =>
    Object.keys(state.byAccountNumber).filter(
      (key) => state.byAccountNumber[key] && state.byAccountNumber[key].hasError
    ).length > 0
);
